// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// Rails CSRF 対応: Axios にトークンとXHRヘッダを付与
import axios from 'axios'
const csrf = document.querySelector('meta[name="csrf-token"]')
if (csrf) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrf.getAttribute('content')
}
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Ionicons Web Components をグローバルに初期化
import { defineCustomElement } from 'ionicons/components/ion-icon.js'
defineCustomElement()

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// ------------------------------------------------------------
// 共通オートマウンタ（MutationObserver）
// data-vue-entry="<entryName>" が付いた要素に対し、
// ./vue_app_<entryName>.js を動的インポートし、初回のみマウントする。
// ------------------------------------------------------------
const mountRegistry = {
  // カスタム名 → ローダ関数（必要に応じて手で追加）。
  // 既定では ./vue_app_${name}.js にフォールバック
}

function loadEntryByName(name) {
  if (mountRegistry[name]) return mountRegistry[name]()
  // 既定の命名規則
  return import(`./vue_app_${name}.js`)
}

function tryMount(el) {
  if (!el || el.dataset.vMounted === '1') return
  const name = el.dataset.vueEntry
  if (!name) return
  el.dataset.vMounted = '1'
  loadEntryByName(name)
    .then((mod) => {
      // エントリモジュールが mount 関数をエクスポートしていれば呼び出す
      const mountFn = mod && (mod.mount || mod.default)
      if (typeof mountFn === 'function') {
        try {
          mountFn(el)
        } catch (e) {
          console.warn(`[auto-mount] mount() threw: ${name}`, e)
          delete el.dataset.vMounted
        }
      }
    })
    .catch((e) => {
      console.warn(`[auto-mount] failed to load entry: ${name}`, e)
      // 失敗したらマウントフラグを戻す（再試行を許可）
      delete el.dataset.vMounted
    })
}

function setupAutoMounter() {
  // 既存DOMにも適用
  document.querySelectorAll('[data-vue-entry]')
    .forEach((el) => tryMount(el))

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes && m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return
        if (node.matches && node.matches('[data-vue-entry]')) tryMount(node)
        node.querySelectorAll && node.querySelectorAll('[data-vue-entry]')
          .forEach((el) => tryMount(el))
      })
    }
  })
  observer.observe(document.documentElement, { childList: true, subtree: true })
}

// 起動
setupAutoMounter()

// 管理UIモーダル（管理者のみ、開発中機能の表示切替）
import '../packs/admin_ui_modal.js'

// 操作説明モード: ON のとき管理者版タブを非表示にする
import { getAdminSetting } from '../utils/adminUiSettings.js'

function applyOperationGuideModeTabs() {
  const on = getAdminSetting('operationGuideMode')
  const tabLi = document.querySelector('a.a_position_check_admin')?.closest('li')
  const panel = document.getElementById('position_check_admin_tab')
  if (tabLi) {
    tabLi.classList.toggle('d-none', !!on)
  }
  if (panel) {
    panel.classList.toggle('d-none', !!on)
  }
}

function initOperationGuideModeTabs() {
  applyOperationGuideModeTabs()
  window.addEventListener('adminUiSettingChanged', (e) => {
    if (e.detail?.key === 'operationGuideMode') {
      applyOperationGuideModeTabs()
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOperationGuideModeTabs)
} else {
  initOperationGuideModeTabs()
}
